import '../i18n-setup/setup';

import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguageSync } from '../../hooks';
import { useSettingsStore } from '../../stores';

export const TranslationProvider = ({ children }: { children: ReactNode }) => {
  const locale = useSettingsStore((store) => store.locale);
  const { i18n } = useTranslation();

  useLanguageSync();

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale, i18n]);

  return children;
};
